'use client';

import dynamic from 'next/dynamic';
import { FC } from 'react';

const DailySdrIntroduce = dynamic(() => import('./components/DailySdrIntroduce'));
const Clients = dynamic(() => import('@/views/heygen/components/Clients'));
const DailySdrHowItWorks = dynamic(() => import('./components/DailySdrHowItWorks'));
const DailySdrFeatures = dynamic(() => import('./components/DailySdrFeatures'));
const DailySdrSocialProof = dynamic(() => import('./components/DailySdrSocialProof'));
const FAQ = dynamic(() => import('@/views/heygen/components/FAQ'));

const PLAYBOOK_FAQS = [
  {
    question: 'How long does setup take?',
    answer:
      'Most teams connect CRM + signal sources in under one day, then receive the first prioritized playbook the next morning.',
  },
  {
    question: 'Can reps execute calls, emails, and chat follow-ups in one place?',
    answer:
      'Yes. The playbook is built for multi-channel execution so SDRs can complete high-priority tasks without bouncing between tools.',
  },
  {
    question: 'Does this work with Salesforce and HubSpot?',
    answer:
      'Yes. Daily SDR Playbook is designed to plug into major CRMs and keep activity logging aligned with existing sales workflows.',
  },
  {
    question: 'How does prioritization work?',
    answer:
      'MarketBetter scores intent signals, website activity, champion movement, and engagement history overnight, then ranks the next-best actions each morning.',
  },
];

const DailySdrPlaybook: FC = () => {
  return (
    <>
      <DailySdrIntroduce />
      <Clients />
      <DailySdrHowItWorks />
      <DailySdrFeatures />
      <DailySdrSocialProof />
      <FAQ titlePrefix='Daily SDR Playbook' highlightedText='FAQs' faqs={PLAYBOOK_FAQS} />
    </>
  );
};

export default DailySdrPlaybook;
